"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var AbstractValueAccessor_1 = require("@utils/AbstractValueAccessor");
var CustomFieldComponent = /** @class */ (function (_super) {
    __extends(CustomFieldComponent, _super);
    function CustomFieldComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update = new core_1.EventEmitter();
        _this.errors = [];
        return _this;
    }
    return CustomFieldComponent;
}(AbstractValueAccessor_1.AbstractValueAccessor));
exports.CustomFieldComponent = CustomFieldComponent;
